import * as React from 'react';

export function useTransientErrorGrace(
  error: unknown,
  resolved: boolean,
  delayMs: number,
): boolean {
  const firstSeenAtRef = React.useRef<number | null>(null);
  const [expired, setExpired] = React.useState(false);
  const hasError = Boolean(error);

  React.useEffect(() => {
    if (!hasError || resolved) {
      firstSeenAtRef.current = null;
      setExpired(false);
      return undefined;
    }

    const firstSeenAt = firstSeenAtRef.current ?? Date.now();
    firstSeenAtRef.current = firstSeenAt;
    const remainingMs = Math.max(0, delayMs - (Date.now() - firstSeenAt));
    if (remainingMs === 0) {
      setExpired(true);
      return undefined;
    }

    setExpired(false);
    const timeout = window.setTimeout(() => setExpired(true), remainingMs);
    return () => window.clearTimeout(timeout);
  }, [hasError, resolved, delayMs]);

  return Boolean(hasError && !resolved && !expired);
}
